{% block uc_media_upload %}
<div class="uc-media-upload">

    <label v-if="label" class="uc-media-upload__label">{{ label }}</label>

    <div class="uc-media-upload__body">

        {# Preview of the selected image #}
        <div v-if="mediaEntity" class="uc-media-upload__preview">
            <img
                v-if="previewUrl"
                :src="previewUrl"
                :alt="fileName"
                class="uc-media-upload__img"
            >
            <span class="uc-media-upload__filename">{{ fileName }}</span>
        </div>
        <div v-else class="uc-media-upload__empty">
            {{ $tc('sellops-ultimate-cart.mediaUpload.emptyLabel') }}
        </div>

        <div class="uc-media-upload__actions">
            <sw-button
                size="small"
                :disabled="disabled"
                @click="showMediaModal = true"
            >
                {{ $tc('sellops-ultimate-cart.mediaUpload.chooseButton') }}
            </sw-button>

            <sw-button
                v-if="mediaEntity"
                size="small"
                :disabled="disabled"
                @click="removeMedia"
            >
                {{ $tc('sellops-ultimate-cart.mediaUpload.removeButton') }}
            </sw-button>
        </div>

    </div>

    <p v-if="helpText" class="uc-media-upload__help">{{ helpText }}</p>

    {# Media library modal — upload or pick, no popover involved #}
    <sw-media-modal-v2
        v-if="showMediaModal"
        :allow-multi-select="false"
        @media-modal-selection-change="onMediaSelectionChange"
        @modal-close="showMediaModal = false"
    />

</div>
{% endblock %}
